import ModalComponent from '../../../components/ModalComponent';
import { Grid2 } from '@mui/material';
import ButtonComponent from '../../../components/ButtonComponent';
import { Controller, useForm } from 'react-hook-form';
import TextFieldComponent from '../../../components/TextFieldComponent';
import { Check, Close } from '@mui/icons-material';
import DropdownComponent from '../../../components/DropdownComponent';
import { zodResolver } from '@hookform/resolvers/zod';
import { SipClientFormSchema } from '../../../services/SipClientService/schemas';
import zod from 'zod';
import {
  useCreateSipClientAsync,
  useUpdateSipClientAsync,
} from '../../../services/SipClientService/hooks/useMutation';
import { useContext, useEffect, useState } from 'react';
import { AppContext } from '../../../context/AppContextProvider';
import { useGetAllUserByLicenseAsync } from '../../../services/UserService/hooks/useMutation';
import { ISipClientProps } from '../../../services/SipClientService/types';

interface SipRegisterEditionModalProps {
  isOpen: boolean;
  onClose: () => void;
  registerSelected?: ISipClientProps;
}
export type SipClientFormInput = zod.infer<typeof SipClientFormSchema>;

const SipRegisterEditionModal = ({
  isOpen,
  onClose,
  registerSelected,
}: SipRegisterEditionModalProps) => {
  const { showSnackbar } = useContext(AppContext);
  const forms = useForm<SipClientFormInput>({
    resolver: zodResolver(SipClientFormSchema),
    defaultValues: {
      domain: '',
      displayName: '',
      sipServerUrl: '',
      password: '',
      username: '',
      isRegistered: false,
    },
  });
  const { control, handleSubmit, reset } = forms;
  const [users, setUsers] = useState<{ value: string; label: string }[]>([]);

  const {
    mutateAsync: mutateCreateSipClientAsync,
    isLoading: isLoadingCreateSipClientAsync,
  } = useCreateSipClientAsync();

  const {
    mutateAsync: mutateUpdateSipClientAsync,
    isLoading: isLoadingUpdateSipClientAsync,
  } = useUpdateSipClientAsync();

  const { mutateAsync: mutateGetAllUserByLicenseAsync } =
    useGetAllUserByLicenseAsync();

  const onSaveOrUpdateSipClient = async (data: SipClientFormInput) => {
    if (!data.id) {
      await mutateCreateSipClientAsync(data, {
        onSuccess: (_) => {
          showSnackbar('Ramal registrado com sucesso.', 'success');
        },
      });
    } else {
      await mutateUpdateSipClientAsync(
        { id: data.id, data },
        {
          onSuccess: (_) => {
            showSnackbar(
              'Ramal atualizado e registrado com sucesso.',
              'success',
            );
          },
        },
      );
    }
    reset();
    onClose();
  };

  useEffect(() => {
    mutateGetAllUserByLicenseAsync(undefined).then((r) => {
      setUsers(
        r.map((us) => {
          return { value: us.id, label: us.name };
        }),
      );
    });
  }, []);

  useEffect(() => {
    if (registerSelected) reset(registerSelected, { keepDefaultValues: true });
    else reset();
  }, [registerSelected]);
  return (
    <ModalComponent onClose={onClose} isOpen={isOpen} title={'Registro'}>
      <Grid2 container columnSpacing={2}>
        <Grid2 size={{ xs: 12, md: 6 }}>
          <Controller
            render={({ field: { value, onChange }, fieldState: { error } }) => (
              <TextFieldComponent
                label={'Usuário'}
                value={value}
                onChangeText={onChange}
                errorMessage={error?.message}
              />
            )}
            name={'username'}
            control={control}
          />
        </Grid2>
        <Grid2 size={{ xs: 12, md: 6 }}>
          <Controller
            render={({ field: { value, onChange }, fieldState: { error } }) => (
              <TextFieldComponent
                label={'Senha'}
                value={value}
                onChangeText={onChange}
                errorMessage={error?.message}
              />
            )}
            name={'password'}
            control={control}
          />
        </Grid2>
        <Grid2 size={{ xs: 12, md: 6 }}>
          <Controller
            render={({ field: { value, onChange }, fieldState: { error } }) => (
              <TextFieldComponent
                label={'Domínio'}
                value={value}
                onChangeText={onChange}
                errorMessage={error?.message}
              />
            )}
            name={'domain'}
            control={control}
          />
        </Grid2>
        <Grid2 size={{ xs: 12, md: 6 }}>
          <Controller
            render={({ field: { value, onChange }, fieldState: { error } }) => (
              <TextFieldComponent
                label={'Nome de exibição'}
                value={value}
                onChangeText={onChange}
                errorMessage={error?.message}
              />
            )}
            name={'displayName'}
            control={control}
          />
        </Grid2>
        <Grid2 size={{ xs: 12, md: 6 }}>
          <Controller
            render={({ field: { value, onChange }, fieldState: { error } }) => (
              <TextFieldComponent
                label={'URL/IP do servidor SIP'}
                value={value}
                errorMessage={error?.message}
                onChangeText={onChange}
              />
            )}
            name={'sipServerUrl'}
            control={control}
          />
        </Grid2>
        <Grid2 size={{ xs: 12, md: 6 }}>
          <Controller
            render={({ field: { value, onChange }, fieldState: { error } }) => (
              <DropdownComponent
                label={'Usuário responsável'}
                value={value}
                errorMessage={error?.message}
                optionLabel={'label'}
                optionValue={'value'}
                options={users}
                onChange={onChange}
              />
            )}
            name={'ownerUserId'}
            control={control}
          />
        </Grid2>
      </Grid2>
      <Grid2 columnSpacing={2} container>
        <ButtonComponent
          startIcon={<Check />}
          type={'submit'}
          onClick={handleSubmit(onSaveOrUpdateSipClient)}
          loading={
            isLoadingCreateSipClientAsync || isLoadingUpdateSipClientAsync
          }
        >
          Salvar
        </ButtonComponent>
        <ButtonComponent
          startIcon={<Close />}
          color={'error'}
          onClick={() => {
            reset();
            onClose();
          }}
          loading={
            isLoadingCreateSipClientAsync || isLoadingUpdateSipClientAsync
          }
        >
          Cancelar
        </ButtonComponent>
      </Grid2>
    </ModalComponent>
  );
};

export default SipRegisterEditionModal;
